export default __webpack_public_path__ + "static/media/radio-checked.23031ddd.svg";